import { brannanConfig } from '@apps/guest/packages/layout-engine/layouts/LayoutBrannan';
import { alohaConfig } from '@apps/guest/packages/layout-engine/layouts/LayoutAloha/LayoutAloha.theme';

export const layoutConfigs = {
  brannan: brannanConfig,
  aloha: alohaConfig,
} as const;

// class name for expandable and collapsible accommodations note used to detect mutations in the dom
export const ACCOMMODATIONS_NOTE_TEXT_CLASS_NAME = 'accommodations-note-text';
